module.exports = __webpack_public_path__ + "img/icon_food-and-bev.806fc93a.svg";